import React from "react";
import { Link as RouterLink, withRouter } from "react-router-dom";

import DropDownList from "@/react-components/DropDownList";
import { debounce } from "@/utils";

class ContainerNavs extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activeIndex: props.activeIndex || 0,
      isShowArrow: false,
    };

    this.scrollableTabRef = React.createRef();
    this.dropDownListRef = React.createRef();
    this.resizeDebounce = debounce(this.resize);
  }

  componentDidMount() {
    this.resize();
    window.addEventListener("resize", this.resizeDebounce);
  }

  componentDidUpdate(prevProps, prevState) {
    const { searchActive, activeIndex: index } = this.props;
    if (prevProps.activeIndex !== index) {
      this.setState({ activeIndex: index });
    }
    if (searchActive) {
      return;
    }
    const { activeIndex } = this.state;
    const temp = document.getElementById(`scrollable-tab-${activeIndex}`);
    temp && temp.scrollIntoView(false);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeDebounce);
    this.resizeDebounce.cancel();
  }

  resize = () => {
    this.setState({
      isShowArrow:
        this.scrollableTabRef.current.clientWidth <
        this.scrollableTabRef.current.scrollWidth,
    });
  };

  handleClick = (index, catagoryid) => {
    const { navChange } = this.props;
    this.setState({
      activeIndex: index,
    });
    navChange && navChange(catagoryid);
  };

  showMenu = () => {
    this.dropDownListRef.current.show();
  };

  handleMenuClick = (item, index) => {
    const {
      isLink,
      history: { push },
      searchActive,
    } = this.props;
    if (isLink || searchActive) {
      push({
        pathname: item.path,
        state: {
          catagoryId: item.itemid,
        },
      });
    } else {
      this.handleClick(index, item.catagoryid);
    }
  };

  render() {
    const { isShowArrow, activeIndex } = this.state;
    const { navs, icMenus, isLink, searchActive, className } = this.props;
    return (
      <React.Fragment>
        <div
          className={`scrollable-tab-container ${
            searchActive ? "black-bottom-border" : ""
          } ${className || ""}`}
        >
          <div
            ref={this.scrollableTabRef}
            className="flex-row scrollable-tab hide-scroll-bar"
          >
            {navs.map((item, index) => {
              let searchActiveClass = "";
              if (index === activeIndex && !searchActive) {
                searchActiveClass = "tab-active";
              }
              if (isLink || searchActive) {
                return (
                  <RouterLink
                    className={`scrollable-tab-item ${searchActiveClass}`}
                    key={index}
                    to={{
                      pathname: item.path,
                      state: {
                        catagoryId: item.itemid,
                      },
                    }}
                    id={`scrollable-tab-${index}`}
                  >
                    {item.text}
                  </RouterLink>
                );
              } else {
                return (
                  <span
                    onClick={() => this.handleClick(index, item.catagoryid)}
                    className={`scrollable-tab-item ${searchActiveClass}`}
                    key={index}
                    id={`scrollable-tab-${index}`}
                    tabIndex="0"
                  >
                    {item.text}
                  </span>
                );
              }
            })}
          </div>
          <div className="scrollable-tab-menu-container">
            {isShowArrow && (
              <div
                className={`scrollable-tab-arrow ${
                  searchActive ? "search-active" : ""
                }`}
                onClick={this.showMenu}
                tabIndex="0"
              >
                <img
                  alt=""
                  src={require("@/assets/images/double-right-arrow.svg")}
                />
              </div>
            )}
            {(icMenus || searchActive) && (
              <div
                className={`scrollable-tab-search ${
                  searchActive ? "black-search" : ""
                } ${isShowArrow ? "scrollable-tab-menu-margin-left" : ""}`}
              >
                {searchActive ? (
                  <div className="scrollable-tab-search-icon scrollable-tab-search-icon-white" />
                ) : (
                  <RouterLink
                    className="scrollable-tab-search-icon"
                    to={icMenus.url}
                  />
                )}
              </div>
            )}
          </div>
          <DropDownList
            ref={this.dropDownListRef}
            list={navs.map((item) => ({
              ...item,
              value: item.text,
            }))}
            onChange={this.handleMenuClick}
            className="scrollable-tab-drop-down-container"
          />
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(ContainerNavs);
